import React from "react";
import { Link } from "react-router-dom";
import { useMedia } from "react-use";
import { Button } from "@mui/material";
import { config as cssConfig } from "@100mslive/roomkit-react";

const SixCareersPosition = () => {
  const isMobile = useMedia(cssConfig.media.sm);
  return (
    <section className="events-page-landing-section events-page-landing-section-space events-page-careers-section-join">
      <div className="events6ix-layout-page-middle">
        <div className="events-page-careers-section-header text-center">
          <div className="events-page-careers-section-header-heading">
            Join Our Mission
          </div>
          <div className="events-page-careers-section-header-text">
            Ready to help us build a more equitable financial future? Explore
            our open positions and become part of the{" "}
            {!isMobile ? <br /> : null} team that's breaking down barriers to
            investment worldwide.
          </div>
          <Button
            variant="outlined"
            to="/demo"
            component={Link}
            color="primary"
            className="events6ix-btn events6ix-btn-primary mt-20"
          >
            Apply Now
          </Button>
        </div>
      </div>
    </section>
  );
};

export default SixCareersPosition;
